import env from '../../config/env'
import { fetcher } from '../../utils/helpers'
import { MetadataServicePath } from './MetadataService'

export const GetMetadataFetcher = () =>
  fetcher({
    baseURL: env.metaUrl,
    url: MetadataServicePath.GetMetadata,
  })

export const GetStaticMetaFile = async () => {
  const res = await fetch('/meta.json')
  const json = await res.json()
  return json
}
